import { Trans } from '@lingui/macro'
import {
  Button,
  colors,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Typography,
} from '@material-ui/core'
import { ExpandMore, Launch } from '@material-ui/icons'
import { css, cx } from 'emotion'
import React from 'react'

import { GoPayCredentials } from '../segments/gopay/GoPayCredentials'
import { WizardStep } from '../typings/types'

const panelTitle = css`
  font-size: 1.1rem !important;
  color: ${colors.grey[700]} !important;
`

const flexColumn = css`
  flex-direction: column;
`

const limitWidth = css`
  width: 40rem;
`

export const GoPayStep: WizardStep = ({ account }) => {
  return (
    <>
      <ExpansionPanel>
        <ExpansionPanelSummary expandIcon={<ExpandMore />}>
          <Typography className={panelTitle}>
            <Trans>Máte již provozní údaje k Vašemu GoPay účtu?</Trans>
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={cx(flexColumn, limitWidth)}>
          <Typography>
            <Trans>
              Vyplňte údaje do následujícího formuláře a stiskem tlačítka
              ověříte jejich správnost.
            </Trans>
          </Typography>
          <GoPayCredentials accountId={account.id} />
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <ExpansionPanel>
        <ExpansionPanelSummary expandIcon={<ExpandMore />}>
          <Typography className={panelTitle}>
            <Trans>Máte pouze testovací údaje k Vašemu GoPay účtu?</Trans>
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={cx(flexColumn, limitWidth)}>
          <Typography>
            <Trans>
              Kontaktujte GoPay a sdělte jim, že budete používat oficiální
              integraci pro Shopify od společnosti Ents Greenwood.
            </Trans>
          </Typography>
          <br />
          <Typography>
            <Trans>
              Testovací údaje můžete vyplnit do následujícího formuláře pokud si
              chcete integraci jen vyzkoušet.
            </Trans>
          </Typography>
          <GoPayCredentials accountId={account.id} useTestMode />
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <ExpansionPanel>
        <ExpansionPanelSummary expandIcon={<ExpandMore />}>
          <Typography className={panelTitle}>
            <Trans>Ještě GoPay účet nemáte registrovaný?</Trans>
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={flexColumn}>
          <Typography>
            <Trans>
              Následující tlačítko vás zavede do na stránku GoPay kde registraci
              provedete. Po zpracování ze strany GoPay, které může trvat i
              několik dní, obdržíte provozní údaje, které vyplníte v
              přecházející sekci.
            </Trans>
            <Button
              variant="contained"
              href="https://account.gopay.com/dodavatele/ents?lang=cs"
              target="_blank"
            >
              <Trans>Registrovat GoPay</Trans>
              <Launch />
            </Button>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </>
  )
}

GoPayStep.getStepLabel = () => <Trans>GoPay účet</Trans>
